
import { defineComponent } from 'vue'
import { useThemeModel } from '@entities/theme'

export default defineComponent({
  name: 'IconCheck',
  setup () {
    const themeModel = useThemeModel()

    return {
      themeModel
    }
  }
})
